<template>
    <div class="activity-wrapper">
        <transition name="vue-table-loader">
            <div class="vue-table-loader" v-if="isLoading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
        </transition>
        <!-- search feature to be added later... -->
        <!-- <div class="row">
            <div class="col-md-12">
                <search :use-local-emit="true" placeholder="Search Activity" @filter-set="handleUpdatedSearch"></search>
            </div>
        </div> -->
        <div class="row pb-2 m-1 activity-title-row">
            <div class="col-md-2 activity-title">User</div>
            <div class="col-md-2 activity-title">Created</div>
            <div class="col-md-1 activity-title">Action</div>
            <div class="col-md-1 activity-title">Details</div>
            <div class="col-md-3 activity-title">Description</div>
        </div>
        <div v-if="showNoActivityMessage" class="row pb-2 m-1 activity-row">
            <div class="col-md-12 text-center pt-4"><strong>No Activity</strong></div>

        </div>
        <div v-else class="row pb-2 m-1 activity-row" v-for="(message, idx) in messages" :key="idx">
            <div class="col-md-2">{{ message.user }}</div>
            <div class="col-md-2">{{ formatTime(message.created_at) }}</div>
            <div class="col-md-1">{{ message.action }}</div>
            <div class="btn btn-outline-primary" v-on:click="displayMessage(message.details)"><i class="fa" aria-hidden="true"></i> View Details</div>
            <div data-toggle="tooltip" data-placement="top" :title="message.description" style="white-space: pre-line" class="col-md-3">{{ message.description }}</div>
        </div>
        <div class="row pt-2 pb-0">
            <div class="col-md-12">
                <list-pagination :pagination="pagination" @paginate="handlePaginationEvent"></list-pagination>
            </div>
        </div>
        <div class="modal fade" id="modalLogMessage">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Message</h4>
                    </div>
                    <div class="modal-body modal-longtext">
                        <div>{{ current_message.message }}</div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
let base_url = window.location.protocol + "//" + window.location.host

import axios from 'axios';
import moment from 'moment-timezone';
import Pagination from '../generic/tables/pagination.vue';
import Search from '../generic/tables/search.vue';

export default {
    name: "activity",
    components: {
        'search': Search,
        'list-pagination': Pagination
    },
    props: {
        entityId: {
            type: [String, Number]
        },
        entityType: String,
        resultsPerPage: {
            type: Number,
            default: 10
        }
    },
    mounted() {
        this.fetchActivity();
        this.getClientTimezone();
    },
    data() {
        return {
            searchTerm: '',
            currentPage: 1,
            isLoading: false,
            messages: [],
            pagination: {
                "current_page": 1,
                "from": 1,
                "last_page": 1,
                "path": "",
                "per_page": 10,
                "to": 1,
                "total": 1
            },
            current_message: {
                message: null
            },
            clientTimezone: null
        };
    },
    computed: {
        showNoActivityMessage() {
            return this.messages.length === 0;
        }
    },
    methods: {
        displayMessage(message) {
            if (message != "") {
                this.current_message.message = message;
            } else {
                this.current_message.message = "No Details";
            }
            $("#modalLogMessage").modal("show");
        },
        formatTime(timestamp) {
            if(this.clientTimezone){
                return moment.utc(timestamp).tz(this.clientTimezone).format('MMM Do YYYY h:mm a');
            } else {
                return moment(timestamp, "YYYY MM DD HH mm ss").format("MMM Do YYYY h:mm a");
            }
        },
        fetchActivity() {
            this.isLoading = true;
            axios.get(base_url + '/pimapi/activity/'+this.entityId+'/entity/'+this.entityType+'?page='+this.currentPage+'&per_page='+this.resultsPerPage+'&query='+this.searchTerm)
            .then((response) => {
                this.messages = response.data.data;
                this.pagination = response.data.meta;
                this.isLoading = false;
            })
            .catch((error) => {
                this.isLoading = false;
                console.log(error);
            });

        },
        handlePaginationEvent(newPage) {
            this.currentPage = newPage;
            this.fetchActivity();
        },
        handleUpdatedSearch(searchTerm) {
            console.log("hey now - a new search term", searchTerm);
        },
        getClientTimezone: function() {
            axios
                .get(
                    base_url +
                    "/client-timezone/",
                    {
                        // 'criteria': criteria,
                    }
                )
                .then(
                    function(response) {
                        this.clientTimezone = response.data.clientTimezone
                    }.bind(this)
                )
                .catch(
                );
        }

    }
};
</script>

<style>
    .activity-wrapper {
        padding: 9px;
        border-color: #DEE0E1;
        border-style: solid;
        border-radius: 3px;
        border-width: 1px;
        margin-bottom: 10px;
    }
    .activity-title {
        font-size: 1.2em;
    }
    .activity-title-row {
        border-bottom-color: #DEE0E1;
        border-bottom-width: 1px;
        border-bottom-style: solid;
    }

</style>
